import { getTenantCacheKey } from "roboflex-thalamus-request-handler";

/** Cache em memória: persiste ao trocar de rota, zera no F5. */
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos
const store = new Map();

/**
 * Monta chave estável incluindo tenant (evita vazamento entre empresas).
 * @param {string} scope
 * @param {Record<string, unknown>} [extra]
 * @returns {string}
 */
export function montarChaveCacheLista(scope, extra = {}) {
  return JSON.stringify({
    tenant: getTenantCacheKey(),
    scope,
    ...extra,
  });
}

/**
 * @param {string} chave
 * @returns {any|null}
 */
export function obterCacheLista(chave) {
  const entry = store.get(chave);
  if (!entry) return null;
  if (Date.now() - entry.timestamp > CACHE_TTL_MS) {
    store.delete(chave);
    return null;
  }
  return entry.payload;
}

/**
 * @param {string} chave
 * @param {any} payload
 */
export function gravarCacheLista(chave, payload) {
  store.set(chave, {
    timestamp: Date.now(),
    payload,
  });
}
